import React, { useMemo } from 'react';
import clsx from 'clsx';
import invariant from 'tiny-invariant';
import styles from './adaptive.module.css';
export const Adaptive = /*#__PURE__*/React.forwardRef(function Adaptive({
  as = 'div',
  children,
  className,
  only,
  from,
  to,
  ...rest
}, ref) {
  const classNames = useMemo(() => clsx(only && getAdaptiveClassName(only, 'only'), from && getAdaptiveClassName(from, 'from'), to && getAdaptiveClassName(to, 'to'), className), [only, from, to, className]);
  return /*#__PURE__*/React.createElement(as, {
    ...rest,
    className: classNames,
    ref
  }, children);
});
function getAdaptiveClassName(adaptive, prefix) {
  const className = styles[`${prefix}-${adaptive}`];
  invariant(className, `Can't find breakpoint for ${prefix} ${adaptive}. Please, check your fronton.config.js for correct breakpoint name`);
  return className;
}